/* eslint-disable import/prefer-default-export */
import axios from 'axios'

const { MOTOS_SNOP_API } = process.env

const apiMotosSnop = axios.create({
  baseURL: MOTOS_SNOP_API,
  withCredentials: true,
  timeout: 960000,
  headers: {
    'Content-Type': 'application/json',
  },
})


export { apiMotosSnop }